<template lang="pug">
v-layout(class='header mt-3 mb-4' row wrap align-center justify-space-between)
  v-flex(class='wrap' xs12 lg7)
    div(v-if='previous' @click='$router.go(-1)' class='previous')
      v-btn(:ripple='false' color='primary' flat small)
        v-icon(left small) arrow_back_ios
        | {{ backName ? backName : 'Назад' }}
    h1(class='headline font-weight-medium page-title')
      slot(name='title')
        | {{ title || '&nbsp;' }}
    h2(v-if='subtitle' class='font-weight-light page-title')
      slot(name='subtitle')
        | {{ subtitle || '&nbsp;' }}        
  v-flex(xs12 lg5 class='extension')
    slot(name='extension')
</template>

<script>
export default {
  props: ['title', 'previous', 'subtitle', 'backName']
}
</script>

<style scoped>
.page-title {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.extension {
  display: flex;
  justify-content: flex-end;
}
.extension >>> button {
  margin-bottom: 0;
}
.extension >>> button:first-child {
  margin-right: 0;
}
@media (max-width: 600px) {
  .extension {
    display: flex;
    justify-content: flex-start;
  }
  .extension >>> button:first-child {
    margin-left: 0;
    margin-right: unset;
  }
}
.previous {
  top: -24px;
  left: 0;
  position: absolute;
}
.previous >>> .v-btn {
  margin: 0;
  padding: 0;
}
.previous >>> .v-btn__content {
  justify-content: flex-start;
}
.previous >>> .v-btn:before {
  display: none;
}
.previous >>> .v-icon {
  margin-right: 8px;
}
.wrap {
  position: relative;
}
.header {
  min-height: 42px;
}
</style>
